// Session timeout configuration
export const SESSION_CONFIG = {
  // Total inactivity timeout in milliseconds (30 minutes)
  IDLE_TIMEOUT: 30 * 60 * 1000,

  // Time threshold to show warning modal (27 minutes = 3 minutes before logout)
  WARNING_THRESHOLD: 27 * 60 * 1000,

  // How often to check for inactivity (every second)
  CHECK_INTERVAL: 1000,

  // Throttle delay for activity events (250ms to avoid excessive updates)
  ACTIVITY_THROTTLE: 250,

  // localStorage key for syncing last activity across tabs
  LAST_ACTIVITY_KEY: 'itsm_last_activity_timestamp',

  // BroadcastChannel name for cross-tab communication
  BROADCAST_CHANNEL_NAME: 'itsm_session_channel',

  // Activity events to track
  ACTIVITY_EVENTS: [
    'mousemove',
    'keydown',
    'click',
    'scroll',
    'touchstart',
    'mousedown',
    'focus',
  ] as const,
};

// Message types for BroadcastChannel cross-tab communication
export const SESSION_MESSAGES = {
  ACTIVITY: 'SESSION_ACTIVITY',
  LOGOUT: 'SESSION_LOGOUT',
  EXTEND: 'SESSION_EXTEND',
} as const;
